<template>
  <div id="app" class="style app-style">
    <div class="wrapper">
      <vue-drawer-layout
        id="nav-drawer"
        ref="drawerLayout"
        :drawer-width="140"
        :z-index="5"
        :drawable-distance="0"
        :content-drawable="true"
        :enable="true"
        :animatable="true"
        :backdrop="false"
      >
        <div class="drawer-content" slot="drawer">
          <div class="row col-12 h-130 pos-menu-header"></div>
          <div class="row">
            <div class="col-1">
              <ul class="nav flex-column">
                <div id="#menu" v-if="user_type === 'Employee'">
                  <li
                    class="nav-item active pt-20"
                    id="transactionAmount"
                    @click="navigateto('/transactionAmount')"
                  >
                    <a class="nav-link ml-8">
                      <i
                        class="icon2-POS-bg align-middle"
                        aria-hidden="true"
                      ></i>
                      <br />
                      <label class="label-14">POS</label>
                    </a>
                  </li>
                  <li
                    class="nav-item "
                    id="changeCamera"
                    v-on:click="changeCamera"
                  >
                    <a class="nav-link ml-8 unverified-item-box">
                      <svg id="Capa_1" enable-background="new 0 0 512 512" class="color-white" viewBox="0 0 512 512" height="25" 
                        width="25" xmlns="http://www.w3.org/2000/svg"><g><path d="m256 256c41.355 0 75-33.645 75-75s-33.645-75-75-75-75 33.645-75 75 33.645 75 75 75zm0-120c24.813 0 45 20.187 45 45s-20.187 45-45 45-45-20.187-45-45 20.187-45 45-45z"/><path d="m58.674 387.766c31.641 19.977 74.693 34.865 122.326 42.443v50.791c0 5.532 3.045 10.615 7.922 13.225 4.865 2.604 10.784 2.332 15.398-.744l90-60c4.173-2.782 6.68-7.465 6.68-12.481s-2.507-9.699-6.68-12.481l-90-60c-4.603-3.069-10.521-3.354-15.398-.744s-7.922 7.693-7.922 13.225v38.809c-41.76-7.13-79.045-20.196-106.31-37.41-28.819-18.196-44.69-40.001-44.69-61.399 0-17.736 10.484-35.429 30-51.245v51.245c0 8.284 6.716 15 15 15h362c8.284 0 15-6.716 15-15v-51.245c19.516 15.816 30 33.51 30 51.245 0 24.386-19.735 43.741-36.292 55.683-25.353 18.287-60.86 32.428-102.684 40.893-8.12 1.643-13.37 9.558-11.727 17.677 1.641 8.106 9.544 13.372 17.678 11.726 45.976-9.305 85.494-25.2 114.282-45.966 31.889-23 48.743-50.668 48.743-80.013 0-32.817-21.228-63.793-60-87.907v-152.093c0-8.284-6.716-15-15-15h-84.787l-16.819-16.82c-8.499-8.5-19.8-13.18-31.82-13.18h-95.146c-12.021 0-23.321 4.681-31.82 13.18l-16.821 16.82h-39.787v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-15c-8.284 0-15 6.716-15 15v152.093c-38.772 24.114-60 55.09-60 87.907 0 32.527 20.289 62.531 58.674 86.766zm152.326 1.262 47.958 31.972-47.958 31.972zm-45-313.028c3.979 0 7.794-1.58 10.606-4.394l21.213-21.213c2.833-2.833 6.601-4.393 10.608-4.393h95.146c4.007 0 7.774 1.56 10.607 4.393l21.213 21.213c2.813 2.814 6.628 4.394 10.607 4.394h76v210h-332c0-11.289 0-191.61 0-210z"/><circle cx="376" cy="121" r="15"/></g></svg>

                      <label class="label-14">Swap Camera</label>
                    </a>
                  </li>
                  <li
                    class="nav-item"
                    id="voidTransactions"
                    @click="navigateto('/voidTransactions')"
                  >
                    <a class="nav-link ml-8">
                      <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 100 125"
                        style="enable-background: new 0 0 100 125"
                        xml:space="preserve"
                        fill="#ffffff"
                        height="50"
                        width="50"
                        class="menu-svg"
                      >
                        <path
                          d="M93.4,49.9c-1.1,0-2,0.9-2,2c0,23.2-18.9,42.2-42.2,42.2S7,75.2,7,52c0-22.3,17.3-40.5,39.2-42l-1.8,1.4
	c-0.9,0.7-1.1,2-0.4,2.9c0.4,0.5,1,0.8,1.6,0.8c0.4,0,0.9-0.1,1.2-0.4l6.8-5.2c0.5-0.4,0.8-1,0.8-1.7S54,6.5,53.5,6.2l-6.8-4.5
	c-0.9-0.6-2.2-0.4-2.8,0.6c-0.6,0.9-0.4,2.2,0.6,2.8L45.9,6c-24,1.6-43,21.6-43,46c0,25.5,20.7,46.2,46.2,46.2S95.4,77.5,95.4,52
	C95.4,50.9,94.5,49.9,93.4,49.9z"
                        />
                        <circle cx="91.8" cy="41.3" r="2.5" />
                        <circle cx="88.6" cy="32" r="2.5" />
                        <circle cx="82.6" cy="23.3" r="2.5" />
                        <circle cx="74.3" cy="15.8" r="2.5" />
                        <circle cx="64.4" cy="10.6" r="2.5" />
                        <path
                          d="M66.9,42c0-1.1-0.9-2.1-2.1-2.1H37.7l4.6-4.6c0.8-0.8,0.8-2.1,0-2.9c-0.4-0.4-0.9-0.6-1.5-0.6c-0.5,0-1.1,0.2-1.5,0.6
	l-8.1,8.1c-0.8,0.8-0.8,2.1,0,2.9l8.1,8.2c0.4,0.4,0.9,0.6,1.5,0.6s1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5s-0.2-1.1-0.6-1.5
	l-4.6-4.7h27.1C65.9,44.1,66.9,43.1,66.9,42z"
                        />
                        <path
                          d="M57.3,73.3c0.6,0,1.1-0.2,1.5-0.6l8.1-8.2c0.8-0.8,0.8-2.1,0-2.9l-8.1-8.1c-0.8-0.8-2.1-0.8-2.9,0c-0.8,0.8-0.8,2.1,0,2.9
	l4.6,4.6H33.3c-1.1,0-2.1,0.9-2.1,2.1c0,1.1,0.9,2.1,2.1,2.1h27.1l-4.6,4.7c-0.4,0.4-0.6,0.9-0.6,1.5s0.2,1.1,0.6,1.5
	C56.2,73.1,56.7,73.3,57.3,73.3z"
                        />
                      </svg>

                      <label class="label-14">Transactions</label>
                    </a>
                  </li>
                  <li
                    class="nav-item"
                    id="adminlogin"
                    v-if="show_admin_login"
                    v-on:click="adminLogin()"
                  >
                    <a class="nav-link ml-8">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 100 125"
                        style="enable-background: new 0 0 100 100"
                        xml:space="preserve"
                        fill="#ffffff"
                        class="menu-svg"
                        height="50"
                        width="50"
                      >
                        <g>
                          <path
                            d="M83.8,49.6L69,34.7c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8L77.6,49H33c-1.1,0-2,0.9-2,2s0.9,2,2,2h44.6L66.2,64.4   c-0.8,0.8-0.8,2,0,2.8c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l14.8-14.8c0.4-0.4,0.6-0.9,0.6-1.4S84.2,50,83.8,49.6z"
                          />
                          <path
                            d="M25.3,81H51c1.1,0,2-0.9,2-2s-0.9-2-2-2H25.3c-4,0-7.3-3.3-7.3-7.3V32.3c0-4,3.3-7.3,7.3-7.3H51c1.1,0,2-0.9,2-2   s-0.9-2-2-2H25.3C19.1,21,14,26.1,14,32.3v37.3C14,75.9,19.1,81,25.3,81z"
                          />
                        </g>
                      </svg>
                      <br />
                      <label class="label-14"
                        >Admin <br />
                        Sign In</label
                      >
                    </a>
                  </li>
                </div>
                <div id="#menu" v-if="user_type === 'Store User'">
                  <li class="nav-item pt-20">
                    <a class="nav-link ml-8">
                      <!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                      <svg
                        version="1.1"
                        class="menu-svg"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 100 125"
                        style="enable-background: new 0 0 100 125"
                        xml:space="preserve"
                        fill="#ffffff"
                        height="50"
                        width="50"
                      >
                        <g id="Layer_2"></g>
                        <g id="Layer_1">
                          <g>
                            <path
                              d="M84,2.5H30c-2.9,0-5.3,2.4-5.3,5.3v8.7H16c-2.9,0-5.3,2.4-5.3,5.3v70.5c0,2.9,2.4,5.3,5.3,5.3h54c2.9,0,5.3-2.4,5.3-5.3
			v-8.7H84c2.9,0,5.3-2.4,5.3-5.3V7.8C89.2,4.9,86.9,2.5,84,2.5z M71,92.2c0,0.5-0.4,0.9-1,0.9H16c-0.5,0-0.9-0.4-0.9-0.9V21.7
			c0-0.5,0.4-0.9,0.9-0.9h8.7v57.5c0,2.9,2.4,5.3,5.3,5.3h41V92.2z M84.9,78.3c0,0.5-0.4,1-1,1H30c-0.5,0-1-0.4-1-1V7.8
			c0-0.5,0.4-1,1-1h54c0.5,0,1,0.4,1,1L84.9,78.3L84.9,78.3z"
                            />
                            <path
                              d="M73,53.2H40.9c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2H73c1.2,0,2.2-1,2.2-2.2S74.2,53.2,73,53.2z"
                            />
                            <path
                              d="M73,66.2H40.9c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2H73c1.2,0,2.2-1,2.2-2.2S74.2,66.2,73,66.2z"
                            />
                            <path
                              d="M73,40.3H40.9c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2H73c1.2,0,2.2-1,2.2-2.2C75.2,41.2,74.2,40.3,73,40.3z"
                            />
                            <path
                              d="M44.7,32h3.9c0.5,0,0.8-0.4,0.8-0.8V25c0-0.5-0.4-0.8-0.8-0.8h-3.9c-0.5,0-0.8,0.4-0.8,0.8v6.2C43.9,31.6,44.3,32,44.7,32
			z"
                            />
                            <path
                              d="M54.4,32h3.9c0.5,0,0.8-0.4,0.8-0.8V20.5c0-0.5-0.4-0.8-0.8-0.8h-3.9c-0.5,0-0.8,0.4-0.8,0.8v10.6
			C53.6,31.6,54,32,54.4,32z"
                            />
                            <path
                              d="M64.1,32H68c0.5,0,0.8-0.4,0.8-0.8v-15c0-0.4-0.4-0.8-0.8-0.8h-3.9c-0.5,0-0.8,0.4-0.8,0.8v15C63.3,31.6,63.7,32,64.1,32z
			"
                            />
                          </g>
                        </g>
                      </svg>
                      <br />
                      <label class="label-14">Reports</label>
                    </a>
                  </li>
                  <li
                    class="nav-item active"
                    id="terminals"
                    @click="navigateto('/terminals')"
                  >
                    <a class="nav-link ml-8">
                      <svg
                        version="1.1"
                        class="menu-svg"
                        height="50"
                        width="50"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 44 55"
                        style="enable-background: new 0 0 44 55"
                        xml:space="preserve"
                        fill="#ffffff"
                      >
                        <g>
                          <circle cx="24" cy="30" r="1" />
                          <circle cx="7" cy="36" r="1" />
                          <path
                            d="M41,4H7C5.3,4,4,5.3,4,7v10c0,0.6,0.4,1,1,1s1-0.4,1-1V7c0-0.6,0.4-1,1-1h34c0.6,0,1,0.4,1,1v24c0,0.6-0.4,1-1,1H17
		c-0.6,0-1,0.4-1,1s0.4,1,1,1h2v3c0,0.6-0.4,1-1,1h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h14c0.6,0,1-0.4,1-1s-0.4-1-1-1h-1
		c-0.6,0-1-0.4-1-1v-3h12c1.7,0,3-1.3,3-3V7C44,5.3,42.7,4,41,4z M27,37c0,0.4,0.1,0.7,0.2,1h-6.4c0.1-0.3,0.2-0.6,0.2-1v-3h6
		C27,34,27,37,27,37z"
                          />
                          <path
                            d="M40,27c0-0.6-0.4-1-1-1H17c-0.6,0-1,0.4-1,1s0.4,1,1,1h22C39.6,28,40,27.6,40,27z"
                          />
                          <path
                            d="M11,20H3c-1.7,0-3,1.3-3,3v14c0,1.7,1.3,3,3,3h8c1.7,0,3-1.3,3-3V23C14,21.3,12.7,20,11,20z M12,37c0,0.6-0.4,1-1,1H3
		c-0.6,0-1-0.4-1-1V23c0-0.6,0.4-1,1-1h8c0.6,0,1,0.4,1,1V37z"
                          />
                        </g>
                      </svg>

                      <label class="label-14">Terminals</label>
                    </a>
                  </li>
                  <!-- <li
                    class="nav-item"
                    id="userlist"
                    @click="navigateto('/userlist')"
                  >
                    <a class="nav-link ml-8">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        class="menu-svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 24 30"
                        style="enable-background: new 0 0 24 24"
                        xml:space="preserve"
                        fill="#ffffff"
                        height="50"
                        width="50"
                      >
                        <g>
                          <g>
                            <path
                              d="M11.914,5c1.378,0,2.5-1.122,2.5-2.5S13.293,0,11.914,0c-1.378,0-2.5,1.122-2.5,2.5S10.536,5,11.914,5z M11.914,1    c0.827,0,1.5,0.673,1.5,1.5c0,0.827-0.673,1.5-1.5,1.5c-0.827,0-1.5-0.673-1.5-1.5C10.414,1.673,11.088,1,11.914,1z M19,6    c1.378,0,2.5-1.122,2.5-2.5S20.379,1,19,1c-1.378,0-2.5,1.122-2.5,2.5S17.622,6,19,6z M19,2c0.827,0,1.5,0.673,1.5,1.5    C20.5,4.327,19.828,5,19,5c-0.827,0-1.5-0.673-1.5-1.5C17.5,2.673,18.174,2,19,2z M16.403,14.237L15.74,8.429    C15.583,7.044,14.486,6,13.19,6h-2.553C9.343,6,8.247,7.044,8.089,8.429l-0.663,5.808c-0.055,0.486,0.095,0.969,0.411,1.323    c0.273,0.305,0.634,0.483,1.027,0.505l0.552,7.472C9.435,23.798,9.653,24,9.914,24h4c0.262,0,0.48-0.202,0.498-0.463l0.552-7.472    c0.392-0.022,0.754-0.199,1.027-0.505C16.309,15.205,16.458,14.723,16.403,14.237z M15.247,14.894    c-0.058,0.064-0.182,0.173-0.366,0.173H14.5c-0.262,0-0.48,0.202-0.499,0.463L13.45,23h-3.071l-0.55-7.47    c-0.02-0.261-0.237-0.463-0.499-0.463H8.95c-0.183,0-0.308-0.109-0.366-0.173c-0.127-0.143-0.187-0.341-0.164-0.544l0.663-5.808    C9.183,7.663,9.852,7,10.639,7h2.553c0.786,0,1.455,0.663,1.556,1.542l0.663,5.808C15.434,14.553,15.374,14.751,15.247,14.894z     M23.355,14.315l-0.641-5.124c-0.155-1.249-1.222-2.19-2.48-2.19h-2.469c-0.278,0-0.558,0.049-0.833,0.147    c-0.26,0.092-0.396,0.378-0.304,0.638c0.093,0.26,0.378,0.397,0.638,0.304c0.167-0.059,0.335-0.089,0.499-0.089h2.469    c0.755,0,1.394,0.565,1.488,1.314l0.641,5.124c0.018,0.144-0.025,0.284-0.121,0.393s-0.229,0.169-0.375,0.169H21.5    c-0.263,0-0.48,0.202-0.499,0.464l-0.467,6.536h-3.069l-0.36-5.037c-0.019-0.275-0.261-0.491-0.534-0.463    c-0.275,0.019-0.483,0.259-0.463,0.534l0.393,5.501C16.521,22.797,16.739,23,17,23h4c0.262,0,0.48-0.203,0.498-0.463l0.467-6.539    c0.394-0.026,0.763-0.206,1.026-0.504C23.276,15.171,23.409,14.742,23.355,14.315z M7.422,16.615    c-0.279-0.026-0.514,0.188-0.534,0.463L6.536,22H3.466L3,15.464C2.981,15.203,2.763,15,2.5,15H2.133    c-0.146,0-0.279-0.06-0.375-0.169s-0.139-0.248-0.121-0.393l0.641-5.124C2.371,8.565,3.01,8,3.766,8h2.469    c0.112,0,0.231,0.017,0.377,0.056c0.267,0.066,0.541-0.09,0.611-0.357c0.07-0.267-0.09-0.541-0.357-0.611    C6.635,7.028,6.435,7,6.234,7H3.766c-1.258,0-2.324,0.941-2.48,2.19l-0.641,5.124c-0.053,0.427,0.079,0.856,0.364,1.179    c0.263,0.298,0.632,0.478,1.026,0.504l0.467,6.539C2.521,22.797,2.739,23,3,23h4c0.262,0,0.48-0.203,0.499-0.464l0.385-5.387    C7.904,16.874,7.696,16.635,7.422,16.615z M5,6c1.378,0,2.5-1.122,2.5-2.5S6.379,1,5,1C3.622,1,2.5,2.122,2.5,3.5S3.622,6,5,6z     M5,2c0.827,0,1.5,0.673,1.5,1.5C6.5,4.327,5.828,5,5,5C4.174,5,3.5,4.327,3.5,3.5C3.5,2.673,4.174,2,5,2z"
                            />
                          </g>
                        </g>
                      </svg>
                      <br />
                      <label class="label-14">Users</label>
                    </a>
                  </li> -->
                  <!-- <li
                    class="nav-item "
                    id="changeCamera"
                    v-on:click="changeCamera"
                  >
                    <a class="nav-link ml-8 unverified-item-box">
                      <svg id="Capa_1" enable-background="new 0 0 512 512" class="color-white" viewBox="0 0 512 512" height="25" 
                        width="25" xmlns="http://www.w3.org/2000/svg"><g><path d="m256 256c41.355 0 75-33.645 75-75s-33.645-75-75-75-75 33.645-75 75 33.645 75 75 75zm0-120c24.813 0 45 20.187 45 45s-20.187 45-45 45-45-20.187-45-45 20.187-45 45-45z"/><path d="m58.674 387.766c31.641 19.977 74.693 34.865 122.326 42.443v50.791c0 5.532 3.045 10.615 7.922 13.225 4.865 2.604 10.784 2.332 15.398-.744l90-60c4.173-2.782 6.68-7.465 6.68-12.481s-2.507-9.699-6.68-12.481l-90-60c-4.603-3.069-10.521-3.354-15.398-.744s-7.922 7.693-7.922 13.225v38.809c-41.76-7.13-79.045-20.196-106.31-37.41-28.819-18.196-44.69-40.001-44.69-61.399 0-17.736 10.484-35.429 30-51.245v51.245c0 8.284 6.716 15 15 15h362c8.284 0 15-6.716 15-15v-51.245c19.516 15.816 30 33.51 30 51.245 0 24.386-19.735 43.741-36.292 55.683-25.353 18.287-60.86 32.428-102.684 40.893-8.12 1.643-13.37 9.558-11.727 17.677 1.641 8.106 9.544 13.372 17.678 11.726 45.976-9.305 85.494-25.2 114.282-45.966 31.889-23 48.743-50.668 48.743-80.013 0-32.817-21.228-63.793-60-87.907v-152.093c0-8.284-6.716-15-15-15h-84.787l-16.819-16.82c-8.499-8.5-19.8-13.18-31.82-13.18h-95.146c-12.021 0-23.321 4.681-31.82 13.18l-16.821 16.82h-39.787v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-15c-8.284 0-15 6.716-15 15v152.093c-38.772 24.114-60 55.09-60 87.907 0 32.527 20.289 62.531 58.674 86.766zm152.326 1.262 47.958 31.972-47.958 31.972zm-45-313.028c3.979 0 7.794-1.58 10.606-4.394l21.213-21.213c2.833-2.833 6.601-4.393 10.608-4.393h95.146c4.007 0 7.774 1.56 10.607 4.393l21.213 21.213c2.813 2.814 6.628 4.394 10.607 4.394h76v210h-332c0-11.289 0-191.61 0-210z"/><circle cx="376" cy="121" r="15"/></g></svg>

                      <label class="label-14">Swap Camera</label>
                    </a>
                  </li> -->
                  <li
                    class="nav-item"
                    id="settings"
                    v-on:click="navigateto('/settings')"
                  >
                    <a class="nav-link ml-8">
                      <svg
                        xmlns:dc="http://purl.org/dc/elements/1.1/"
                        xmlns:cc="http://creativecommons.org/ns#"
                        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                        xmlns:svg="http://www.w3.org/2000/svg"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                        version="1.1"
                        class="menu-svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 100 125"
                        height="50"
                        width="50"
                      >
                        <g transform="translate(0,-952.36218)">
                          <path
                            style="
                              text-indent: 0;
                              text-transform: none;
                              direction: ltr;
                              block-progression: tb;
                              baseline-shift: baseline;
                              color: #000000;
                              enable-background: accumulate;
                            "
                            d="m 43.999968,957.36216 c -3.2894,0 -6,2.7106 -6,6 l 0,5.09375 c -4.3936,1.55574 -8.3008,4.00919 -11.7188,7.03125 l -4.562401,-2.53125 c -2.8787,-1.5965 -6.5616,-0.53141 -8.1563,2.34375 l -5.8124998,10.5 c -1.5885,2.86414 -0.5706,6.55723 2.3124998,8.15624 l 4.5313,2.5 c -0.3189,1.9284 -0.5938,3.8907 -0.5938,5.9063 0,2.0133 0.2756,3.9486 0.5938,5.875 l -4.5313,2.5312 c -2.8830998,1.5991 -3.9009998,5.2921 -2.3124998,8.1563 l 5.8124998,10.5 c 1.5947,2.8751 5.2776,3.9402 8.1563,2.3437 l 4.562401,-2.5312 c 3.4149,3.0161 7.3313,5.4464 11.7188,7 l 0,5.125 c 0,3.2894 2.7106,6 6,6 l 12,0 c 3.2894,0 6,-2.7106 6,-6 l 0,-5.125 c 4.3876,-1.5536 8.3039,-3.9839 11.7188,-7 l 4.5624,2.5312 c 2.8786,1.5965 6.5617,0.5314 8.1563,-2.3437 l 5.8125,-10.5 c 1.5886,-2.8642 0.5707,-6.5572 -2.3125,-8.1563 l -4.5313,-2.5312 c 0.318,-1.9264 0.5938,-3.8617 0.5938,-5.875 0,-2.0156 -0.2751,-3.9779 -0.5938,-5.9063 l 4.5313,-2.5 c 2.8832,-1.599 3.9011,-5.2921 2.3125,-8.15623 l -5.8125,-10.5 c -1.5946,-2.87516 -5.2778,-3.94026 -8.1563,-2.34375 l -4.5624,2.53125 c -3.418,-3.02206 -7.3252,-5.47552 -11.7188,-7.03125 l 0,-5.09375 c 0,-3.2894 -2.7106,-6 -6,-6 l -12,0 z m 0,4 12,0 c 1.1426,0 2,0.85739 2,2 l 0,6.5 c 0,0.84506 0.5993,1.65535 1.4062,1.90625 4.8464,1.48736 9.2121,4.0992 12.7813,7.53125 0.6084,0.58397 1.6036,0.71668 2.3437,0.3125 l 5.6876,-3.15625 c 0.9972,-0.5531 2.1637,-0.21941 2.7187,0.78125 l 5.8125,10.50004 c 0.5611,1.0116 0.2427,2.1681 -0.75,2.7187 l -5.6875,3.1563 c -0.7444,0.40689 -1.1702,1.3251 -1,2.1562 0.4455,2.1263 0.6875,4.3274 0.6875,6.5938 0,2.2663 -0.242,4.4363 -0.6875,6.5625 -0.1846,0.8401 0.2439,1.7774 1,2.1875 l 5.6875,3.1562 c 0.9927,0.5506 1.3111,1.7071 0.75,2.7188 l -5.8125,10.5 c -0.555,1.0006 -1.7215,1.3343 -2.7187,0.7812 l -5.6876,-3.1562 c -0.7337,-0.4122 -1.7282,-0.2928 -2.3437,0.2812 -3.5692,3.432 -7.9349,6.0439 -12.7813,7.5313 -0.817,0.2539 -1.4179,1.082 -1.4062,1.9375 l 0,6.5 c 0,1.1426 -0.8574,2 -2,2 l -12,0 c -1.1426,0 -2,-0.8574 -2,-2 l 0,-6.5 c 0.012,-0.8554 -0.5894,-1.6835 -1.4062,-1.9375 -4.8464,-1.4874 -9.212,-4.0993 -12.7813,-7.5313 -0.6155,-0.574 -1.61,-0.6933 -2.3437,-0.2812 l -5.687601,3.1562 c -0.9972,0.5531 -2.1637,0.2194 -2.7187,-0.7812 l -5.8125,-10.5 c -0.5611,-1.0117 -0.2427,-2.1682 0.75,-2.7188 l 5.6875,-3.1562 c 0.7561,-0.4101 1.1846,-1.3474 1,-2.1875 -0.4455,-2.1262 -0.6875,-4.2962 -0.6875,-6.5625 0,-2.2664 0.242,-4.4675 0.6875,-6.5938 0.1702,-0.8311 -0.2556,-1.7493 -1,-2.1562 l -5.6875,-3.1563 c -0.9927,-0.5506 -1.3111,-1.7071 -0.75,-2.7187 l 5.8125,-10.50003 c 0.555,-1.00066 1.7215,-1.33436 2.7187,-0.78125 l 5.687601,3.15625 c 0.74,0.40412 1.7354,0.27142 2.3437,-0.3125 3.5693,-3.43205 7.9347,-6.0439 12.7813,-7.53125 0.8069,-0.25095 1.4046,-1.06122 1.4062,-1.90625 l 0,-6.5 c 0,-1.14262 0.8574,-2 2,-2 z m 6,21 c -11.022,0 -20,8.97794 -20,20.00004 0,11.0219 8.978,20 20,20 11.022,0 20,-8.9781 20,-20 0,-11.0221 -8.978,-20.00003 -20,-20.00003 z m 0,4 c 8.8603,0 16,7.13964 16,16.00004 0,8.8602 -7.1397,16 -16,16 -8.8602,0 -16,-7.1398 -16,-16 0,-8.8604 7.1398,-16.00003 16,-16.00003 z"
                            fill="#ffffff"
                            fill-opacity="1"
                            stroke="none"
                            marker="none"
                            visibility="visible"
                            display="inline"
                            overflow="visible"
                          />
                        </g>
                      </svg>

                      <label class="label-14">Settings</label>
                    </a>
                  </li>
                  <li class="nav-item" v-on:click="openLogoutModal()">
                    <a class="nav-link ml-8">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 100 125"
                        style="
                          enable-background: new 0 0 100 100;
                          -webkit-transform: scaleX(-1);
                          transform: scaleX(-1);
                        "
                        xml:space="preserve"
                        fill="#ffffff"
                        height="50"
                        width="50"
                        class="menu-svg"
                      >
                        <g>
                          <path
                            d="M83.8,49.6L69,34.7c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8L77.6,49H33c-1.1,0-2,0.9-2,2s0.9,2,2,2h44.6L66.2,64.4   c-0.8,0.8-0.8,2,0,2.8c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l14.8-14.8c0.4-0.4,0.6-0.9,0.6-1.4S84.2,50,83.8,49.6z"
                          />
                          <path
                            d="M25.3,81H51c1.1,0,2-0.9,2-2s-0.9-2-2-2H25.3c-4,0-7.3-3.3-7.3-7.3V32.3c0-4,3.3-7.3,7.3-7.3H51c1.1,0,2-0.9,2-2   s-0.9-2-2-2H25.3C19.1,21,14,26.1,14,32.3v37.3C14,75.9,19.1,81,25.3,81z"
                          />
                        </g>
                      </svg>
                      <br />
                      <label class="label-14">Sign Out</label>
                    </a>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </vue-drawer-layout>
      <div slot="content">
        <cp-header></cp-header>
        <div>
          <div v-if="!$online" class="offline-div">Oops! You are offline!</div>
          <router-view />
        </div>
      </div>
    </div>

    <div class="snackbar" v-if="snackWithButtons">
      <span>New version available</span>
      <button
        v-on:click="refreshApp"
        class="btn btn-success center-block btn-green ml-2"
      >
        Refresh
      </button>
    </div>
    <!-- View Logout modal Start -->
    <b-modal
      id="logout-modal"
      centered
      ref="logout-modal"
      hide-header
      hide-footer
    >
      <div class="row row-top-margin-div">
        <div class="col-4 offset-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 100 125"
            style="
              enable-background: new 0 0 100 100;
              -webkit-transform: scaleX(-1);
              transform: scaleX(-1);
            "
            xml:space="preserve"
            fill="#179346"
            width="120"
            height="120"
          >
            <g>
              <path
                d="M83.8,49.6L69,34.7c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8L77.6,49H33c-1.1,0-2,0.9-2,2s0.9,2,2,2h44.6L66.2,64.4   c-0.8,0.8-0.8,2,0,2.8c0.4,0.4,0.9,0.6,1.4,0.6s1-0.2,1.4-0.6l14.8-14.8c0.4-0.4,0.6-0.9,0.6-1.4S84.2,50,83.8,49.6z"
              />
              <path
                d="M25.3,81H51c1.1,0,2-0.9,2-2s-0.9-2-2-2H25.3c-4,0-7.3-3.3-7.3-7.3V32.3c0-4,3.3-7.3,7.3-7.3H51c1.1,0,2-0.9,2-2   s-0.9-2-2-2H25.3C19.1,21,14,26.1,14,32.3v37.3C14,75.9,19.1,81,25.3,81z"
              />
            </g>
          </svg>
        </div>
      </div>
      <div class="row">
        <div class="col-12 modal-text">
          <span>Are you sure you want<br />to Sign Out?</span>
        </div>
      </div>
      <div class="row row-top-margin-div">
        <div class="col-12 modal-text">
          <button
            type="button"
            class="btn-medium-black btn-shadow-btn-black"
            style="height: 60px"
            @click="logout()"
          >
            <span class="white-text-label font-weight-500">Yes, I'm Sure</span>
          </button>
        </div>
      </div>
      <div class="row row-top-margin-div">
        <div class="col-12 modal-text">
          <button
            type="button"
            class="btn-medium-gray"
            style="height: 60px"
            @click="closeLogoutModal()"
          >
            <span class="black-small-text-label font-weight-600">Go Back</span>
          </button>
        </div>
      </div>
    </b-modal>
    <!-- View Logout modal End -->
    <!-- App installation modal -->
    <b-modal
      id="install-app"
      centered
      ref="install-app"
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div class="row row-top-margin-div">
        <div class="col-12 text-center">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="120"
            height="120"
            viewBox="0 0 100 125"
            style="enable-background: new 0 0 100 125"
            xml:space="preserve"
            fill="#e24141"
          >
            <path
              d="M96.2,47.5l-22-38c-0.4-0.6-1-1-1.7-1h-44c-0.7,0-1.4,0.4-1.7,1l-22,37.9c-0.4,0.6-0.4,1.4,0,2l22,38.1c0.4,0.6,1,1,1.7,1
	h44c0.7,0,1.4-0.4,1.7-1l22-38C96.6,48.9,96.6,48.1,96.2,47.5z M71.3,84.5H29.7L8.8,48.4l20.8-35.9h41.7l20.8,36L71.3,84.5z
	 M50.5,60.5c1.1,0,2-0.9,2-2v-30c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v30C48.5,59.6,49.4,60.5,50.5,60.5z M48.4,66.4
	c-0.6,0.6-0.9,1.3-0.9,2.1c0,0.8,0.3,1.6,0.9,2.1s1.3,0.9,2.1,0.9c0.8,0,1.6-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1
	c0-0.8-0.3-1.6-0.9-2.1C51.5,65.3,49.5,65.3,48.4,66.4z"
            />
          </svg>
        </div>
      </div>
      <div class="row">
        <div class="col-12 modal-text">
          <span>Please Install The App To Proceed Further!</span>
        </div>
      </div>
    </b-modal>
    <!-- View Logout modal End -->
  </div>
</template>

<style lang="scss">
@import "/assets/styles/main.scss";
</style>

<script>
import Header from "./components/Layouts/Header/Header.vue";
import auth from "./api/login.js";
import terminal from "./api/setterminal.js";
import { isMobile } from "mobile-device-detect";
export default {
  name: "App",
  data() {
    return {
      refreshing: false,
      registration: null,
      snackWithButtons: false,
      user_type: localStorage.getItem("login_user_type"),
      show_admin_login: false,
      cameraType: ""
    };
  },
  components: {
    "cp-header": Header,
  },
  mounted() {
    var self = this;
    if (isMobile && process.env.VUE_APP_TEST_MODE != true) {
      const isInStandaloneMode = () =>
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone ||
        document.referrer.includes("android-app://");
      if (!isInStandaloneMode()) {
        self.$bvModal.show("install-app");
      }
    }
    self.$root.$on("drawer", function (data) {
      self.$refs.drawerLayout.toggle();
    });
    self.$root.$on("show_admin_login", function (data) {
      self.show_admin_login = data;
    });
    self.$root.$on("user_type", function (data) {
      self.user_type = data;
    });
    // this is to place the nav-active class correctly over the menu
    self.$root.$on("navigate", function (data) {
      $(".nav-item").removeClass("active");
      $("#" + data).addClass("active");
    });
    if (
      self.detectBrowser() === "Safari" ||
      self.detectBrowser() === "safari"
    ) {
      const isInStandaloneMode = () =>
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone ||
        document.referrer.includes("android-app://");
      if (isInStandaloneMode()) {
        console.log("pwa installed");
      } else {
        self.$bvModal.show("install-app");
      }
    }
  },
  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.refreshing) return;
        this.refreshing = true;
        console.log("About to refresh for a new version");
        window.location.reload(true);
      });
    }
    this.redirect();
    var self = this;
    this.$router.beforeEach((to, from, next) => {
      window.history.forward(1);
      if (self.$online) {
        next();
      }
    });
  },

  methods: {
    detectBrowser() {
      var navUserAgent = navigator.userAgent;
      var browserName = navigator.appName;
      var browserVersion = "" + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var tempNameOffset, tempVersionOffset, tempVersion;

      if ((tempVersionOffset = navUserAgent.indexOf("Opera")) != -1) {
        browserName = "Opera";
        browserVersion = navUserAgent.substring(tempVersionOffset + 6);
        if ((tempVersionOffset = navUserAgent.indexOf("Version")) != -1)
          browserVersion = navUserAgent.substring(tempVersionOffset + 8);
      } else if ((tempVersionOffset = navUserAgent.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        browserVersion = navUserAgent.substring(tempVersionOffset + 5);
      } else if ((tempVersionOffset = navUserAgent.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        browserVersion = navUserAgent.substring(tempVersionOffset + 7);
      } else if ((tempVersionOffset = navUserAgent.indexOf("Safari")) != -1) {
        browserName = "Safari";
        browserVersion = navUserAgent.substring(tempVersionOffset + 7);
        if ((tempVersionOffset = navUserAgent.indexOf("Version")) != -1)
          browserVersion = navUserAgent.substring(tempVersionOffset + 8);
      } else if ((tempVersionOffset = navUserAgent.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        browserVersion = navUserAgent.substring(tempVersionOffset + 8);
      } else if (
        (tempNameOffset = navUserAgent.lastIndexOf(" ") + 1) <
        (tempVersionOffset = navUserAgent.lastIndexOf("/"))
      ) {
        browserName = navUserAgent.substring(tempNameOffset, tempVersionOffset);
        browserVersion = navUserAgent.substring(tempVersionOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim version
      if ((tempVersion = browserVersion.indexOf(";")) != -1)
        browserVersion = browserVersion.substring(0, tempVersion);
      if ((tempVersion = browserVersion.indexOf(" ")) != -1)
        browserVersion = browserVersion.substring(0, tempVersion);

      if (navigator.userAgent.match("CriOS")) {
        browserName = "Chrome";
      }
      return browserName;
    },
    redirect() {
      if (localStorage.getItem("unique_terminal_id") == null) {
        if (localStorage.getItem("token") == null) {
          //if no terminal is set in the current device redirect to admin login screen
          this.$router.push("/login").catch((err) => {});
        } else {
          this.$router.push("/terminals").catch((err) => {});
          this.$root.$emit("show_sign_out", false);
        }
      } else {
        //fetch the terminal related details and check if employee login is enabled or not
        let self = this;
        var request = {
          terminal_unique_id: localStorage.getItem("unique_terminal_id"),
        };
        terminal
          .getTerminalDetails(request)
          .then((response) => {
            if (response.code == 200) {
              if (response.data.pos_employee_login == 1) {
                if (localStorage.getItem("token") == null) {
                  //emit the icon name to show at the top left of the header
                  self.$root.$emit("showicon", "none");
                  this.$router.push("/employeeLogin").catch((err) => {});
                } else {
                  self.show_admin_login = false;
                  self.$root.$emit("showicon", "hamburger");
                  if (localStorage.getItem("login_user_type") === "Employee") {
                    self.$router.push("/transactionAmount").catch((err) => {});
                    self.$root.$emit("show_sign_out", true);
                  } else {
                    self.$router.push("/terminals").catch((err) => {});
                    self.$root.$emit("show_sign_out", false);
                  }
                }
              } else {
                self.show_admin_login = true;
                if (localStorage.getItem("token") == null) {
                  localStorage.removeItem("token");
                  localStorage.removeItem("login_response");
                  localStorage.removeItem("login_user_type");
                  localStorage.removeItem("terminal_login_response");
                  localStorage.removeItem("view_user");
                  localStorage.setItem("token", response.data.token);
                  axios.defaults.headers.common["Authorization"] =
                    response.data.token;
                  //emit the icon name to show at the top left of the header
                  self.$root.$emit("showicon", "hamburger");
                  //redirecting to the transaction amount page
                  self.$router.push("/transactionAmount").catch((err) => {});
                  localStorage.setItem("login_user_type", "Employee");
                  localStorage.setItem(
                    "terminal_login_response",
                    JSON.stringify(response.data)
                  );
                  self.$root.$emit(
                    "user_type",
                    localStorage.getItem("login_user_type")
                  );
                } else {
                  self.$root.$emit("showicon", "hamburger");
                  if (localStorage.getItem("login_user_type") === "Employee") {
                    self.$router.push("/transactionAmount").catch((err) => {});
                  } else {
                    self.$router.push("/terminals").catch((err) => {});
                    self.$root.$emit("show_sign_out", false);
                  }
                }
              }
            } else {
              alert(response.message);
            }
          })
          .catch(function (error) {});
      }
    },
    openLogoutModal() {
      this.$bvModal.show("logout-modal");
    },
    closeLogoutModal() {
      this.$bvModal.hide("logout-modal");
    },
    adminLogin() {
      this.$refs.drawerLayout.toggle();
      this.$root.$emit("showicon", "hamburger");
      this.$router.push("/login").catch((err) => {});
    },
    // navigate to new page
    navigateto(route) {
      if (
        route === "/settings" &&
        localStorage.getItem("unique_terminal_id") == null
      ) {
        alert("Please setup terminal for this device to enable settings.");
        return false;
      }
      this.$root.$emit("showicon", "hamburger");
      this.$refs.drawerLayout.toggle();
      $(".nav-item").removeClass("active");
      route = route.replace("/", "");
      $("#" + route).addClass("active");
      this.$router.push(route);
    },
    // shows refreshed UI
    showRefreshUI(e) {
      // Display a snackbar inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;
      this.snackWithButtons = true;
    },
    //this function refreshes the PWA to the lastest version
    refreshApp() {
      this.snackWithButtons = false;
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");
    },
    //logout function
    logout() {
      var self = this;
      auth
        .logout()
        .then((response) => {
          if (response.code == 200) {
            $(".nav-item").removeClass("active");
            localStorage.removeItem("token");
            localStorage.removeItem("store_user");
            localStorage.removeItem("user_type");
            localStorage.removeItem("terminal_login_response");
            localStorage.removeItem("store_user_type");
            localStorage.removeItem("login_response");
            localStorage.removeItem("view_user");
            localStorage.removeItem("view_terminal");
            delete axios.defaults.headers.common["Authorization"];
            self.$refs.drawerLayout.toggle();
            self.$root.$emit("showicon", "none");
            self.$root.$emit("user_type", "");
            self.$bvModal.hide("logout-modal");
            self.redirect();
            localStorage.removeItem("login_user_type");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changeCamera() {
      let msg = ""
      if (
        localStorage.getItem("unique_terminal_id") == null
      ) {
        alert("Please setup terminal for this device to enable settings.");
        return false;
      }

      if (localStorage.getItem("camera_type") == "front") {
        this.cameraType = "rear";
        msg = "Camera changed to Rear."
      } else {
        this.cameraType = "front";
        msg = "Camera changed to Front."
      }

      let request = {
        terminal_unique_id: localStorage.getItem("unique_terminal_id"),
        camera_option: this.cameraType,
      };
      
      terminal
        .swapCameraSettings(request)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            alert(msg);
            localStorage.setItem("camera_type", response.data.camera_option);
          } else if (response.code == 401) {
            self.getConfirmation();
          } else {
            alert(response.message);
          }
        })
        .catch(function (error) {console.log(error);});
    },
    getConfirmation() {
      var retVal = confirm("Your token has expired, do you want to logout?");
      if (retVal == true) {
        this.$router.push("/");
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>